import * as components from './components';
import Sapphires from '../Shop/components/Sapphires';
const Views = {
    createClub: components.CreateClub,
    joinClub: components.JoinClub,
    editClub: components.EditClub,
    disbandClub: components.DisbandClub,
    selectAvatar: components.SelectAvatar,
    selectCountry: components.SelectCountry,
    purchase: components.Purchase,
    deleteMember: components.DeleteMember,
    editMemberInfo: components.EditMemberInfo,
    changeRole: components.ChangeRole,
    exchange: components.Exchange,
    buyLevel: components.BuyLevelPop,
    notEnoughFunds: Sapphires,
    renewLevel: components.ClubRenewLevel,
    comingSoon: components.ComingSoon,
    unionNotice: components.UnionNotice,
    createUnion: components.CreateUnion,
    joinUnion: components.JoinUnion,
    unionAuthority: components.UnionAuthority,
    disbandUnion: components.DisbandUnion,
    upgradeToJoin: components.UpgradeToJoin,
    upgradeToCreate: components.UpgradeToCreate,
    memberMenu: components.MemberMenu,
    quitMemberClub: components.QuitMemberClub,
    unionConfirmation: components.UnionConfirmation,
    clubConfirmation: components.ClubConfirmation,
    agentDetails: components.AgentDetails,
    exportData: components.ExportData,
    dailyBonus: components.DailyBonus,
    createClubCode: components.CreateClubCode,
    betYourHand: components.BetYourHand,
    clubInfo: components.ClubInfo,
    tournamentCasinoRegister: components.tournamentCasinoRegister,
    tournamentCasinoUnregister: components.tournamentUnregister,
    tournamentCasinoBadBet: components.tournamentCasinoBadBet,
    tournamentCasinoBonus: components.tournamentBonusMessage,
    tournamentCasinoCompleted: components.tournamentCompleted,
    tournamentCasinoFinished: components.tournamentFinished,
    tournamentCasinoLowBalance: components.tournamentLowBalance,
    tournamentCasinoOutOfSpins: components.tournamentOutOfSpins,
    tournamentCasinoRebuy: components.tournamentRebuy,
    tournamentCasinoReminder: components.tournamentReminder,
    tournamentCasinoServerMessage: components.tournamentServerMessage,
    tournamentCasinoStartInformation: components.tournamentStartInformation,
    tournamentCasinoSuccessfull: components.tournamentSuccessfull,
    tournamentCasinoUnregisterSuccessfull:components.tournamentUnregisterSuccessfull,
    lowBalance: components.lowBalance
};

export default Views;
